import { ArchetypeDefinition } from '../../archetypeTypes';

// Bridge for ConceptualAbstractionSystem initial archetypes
export const METAPHYSICS_ARCHETYPES: ArchetypeDefinition[] = [
    {
        key: 'the_void',
        name: 'The Void',
        description: 'Primordial emptiness and potential before differentiation.',
        category: 'Metaphysics',
        tags: ['origin', 'potential', 'silence'],
        // Low complexity and waves; stability from quiet system; minimal structure
        weights: { stability: 0.35, nodeCount: 0.05, edgeCount: 0.05, waveIntensity: 0.05, averageNodeEnergy: 0.2, fractalDimension: 0.3 }
    },
    {
        key: 'the_mother',
        name: 'The Mother',
        description: 'Nurturing generativity supporting emergence and growth.',
        category: 'Metaphysics',
        tags: ['nurture', 'birth', 'care'],
        // Coherence in breath, stable energy, building connections
        weights: { breathingQuality: 0.35, stability: 0.25, averageNodeEnergy: 0.2, nodeCount: 0.2 }
    },
    {
        key: 'the_flow',
        name: 'The Flow',
        description: 'Dynamic transformation and continuous becoming.',
        category: 'Metaphysics',
        tags: ['movement', 'change', 'river'],
        // Strong waves, moderate fractal emergence, adequate energy
        weights: { waveIntensity: 0.4, energyLevel: 0.25, fractalDimension: 0.2, stability: 0.15 }
    }
];


